var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgBenifitsPos2(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 116,
    height: 116,
    viewBox: "0 0 116 116",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "icon_increasesales",
    transform: "translate(-879 -1620)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "bar-graph",
    transform: "translate(905 1646)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_6070",
    "data-name": "Path 6070",
    d: "M60,10H4a2,2,0,0,0-2,2v7H17l2-2H62V12A2,2,0,0,0,60,10Z",
    fill: "#f9556d"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_6071",
    "data-name": "Path 6071",
    d: "M15,15H13V13h2Zm-4,0H9V13h2ZM7,15H5V13H7Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_6072",
    "data-name": "Path 6072",
    d: "M60,9H4a3,3,0,0,0-3,3V52a3,3,0,0,0,3,3H60a3,3,0,0,0,3-3V12A3,3,0,0,0,60,9Zm1,43a1,1,0,0,1-1,1H4a1,1,0,0,1-1-1V12a1,1,0,0,1,1-1H60a1,1,0,0,1,1,1Z",
    fill: "#01358d"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_6073",
    "data-name": "Path 6073",
    d: "M48,19v2h7.586L39,37.586l-11-11L5.293,49.293l1.414,1.414L13,44.414V51h6V38.414l2-2V51h6V30.414l1-1,1,1V51h6V36.414l2,2V51h6V36.414l2-2V51h6V28.414l6-6V30h2V19ZM17,49H15V42.414l2-2Zm8,0H23V34.414l2-2Zm8,0H31V32.414l2,2Zm8,0H39V40.414l2-2Zm8,0H47V32.414l2-2Z",
    fill: "#01358d"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_6074",
    "data-name": "Path 6074",
    d: "M5,21H21V31H5Z",
    fill: "#32e2a9"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_6075",
    "data-name": "Path 6075",
    d: "M5,21H7v2H5Z",
    fill: "#01358d"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_6076",
    "data-name": "Path 6076",
    d: "M9,21H21v2H9Z",
    fill: "#01358d"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_6077",
    "data-name": "Path 6077",
    d: "M5,25H7v2H5Z",
    fill: "#01358d"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_6078",
    "data-name": "Path 6078",
    d: "M9,25H21v2H9Z",
    fill: "#01358d"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_6079",
    "data-name": "Path 6079",
    d: "M5,29H7v2H5Z",
    fill: "#01358d"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_6080",
    "data-name": "Path 6080",
    d: "M9,29H21v2H9Z",
    fill: "#01358d"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Ellipse_1754",
    "data-name": "Ellipse 1754",
    transform: "translate(879 1620)",
    fill: "none",
    stroke: "#01358d",
    strokeLinecap: "round",
    strokeWidth: 2,
    strokeDasharray: "0 4"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 58,
    cy: 58,
    r: 58,
    stroke: "none"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 58,
    cy: 58,
    r: 57,
    fill: "none"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBenifitsPos2);
export default __webpack_public_path__ + "static/media/benifits-pos-2.8bf9f22d9a60a6b1bbbff34291378eb0.svg";
export { ForwardRef as ReactComponent };